<template>
    <btn :priority="cssPriority.DEFAULT" :text="text" @click="clickBackPage()" />
</template>

<script>
    import Btn from "../atoms/Btn.vue";
    import { cssPriority } from '../../view-model/enum/CSSPriority'
    import {getClickAllEvent} from "../../util/Ga4EventUtil";

    export default {
        name: "BtnHistoryBack",
        components: {Btn},
        emits: ['backPageClicked'],
        data() {
            return {
                cssPriority: cssPriority
            }
        },
        props: {
            /**
             * ボタンテキスト
             */
            text: {
                type: String,
                required: true
            }
        },
        methods: {
            // 前のページに戻る
            clickBackPage() {
                this.$emit('backPageClicked');
                getClickAllEvent(document.referrer, this.text);
                history.back();
            }
        }
    }
</script>
